const AdminSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">⚙️ Quản Trị (Admin)</h2>
            <p className="text-slate-700">
                Tính năng dành cho giáo viên/quản trị viên.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Các tính năng quản trị:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-4 bg-indigo-50 rounded-lg border border-indigo-200">
                        <h4 className="font-semibold text-indigo-900 mb-2">👥 Quản lý người dùng</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Tạo tài khoản sinh viên/admin</li>
                            <li>• Import hàng loạt từ file CSV</li>
                            <li>• Xem danh sách người dùng</li>
                        </ul>
                    </div>
                    <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                        <h4 className="font-semibold text-green-900 mb-2">📚 Quản lý lớp học</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Tạo/xóa lớp học</li>
                            <li>• Thêm/xóa sinh viên</li>
                            <li>• Upload tài liệu</li>
                        </ul>
                    </div>
                    <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                        <h4 className="font-semibold text-purple-900 mb-2">💰 Quản lý học phí</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Tạo khoản học phí cho sinh viên</li>
                            <li>• Xác nhận thanh toán (toàn bộ/một phần)</li>
                            <li>• Xem lịch sử thanh toán</li>
                        </ul>
                    </div>
                    <div className="p-4 bg-orange-50 rounded-lg border border-orange-200">
                        <h4 className="font-semibold text-orange-900 mb-2">📝 Quản lý bài tập</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Tạo bài kiểm tra mới</li>
                            <li>• Thêm câu hỏi và đáp án</li>
                            <li>• Xem kết quả sinh viên</li>
                        </ul>
                    </div>
                    <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                        <h4 className="font-semibold text-blue-900 mb-2">📖 Quản lý bài giảng</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Viết bài giảng lý thuyết</li>
                            <li>• Upload hình ảnh minh họa</li>
                            <li>• Publish/unpublish bài viết</li>
                        </ul>
                    </div>
                    <div className="p-4 bg-pink-50 rounded-lg border border-pink-200">
                        <h4 className="font-semibold text-pink-900 mb-2">💬 Quản lý hỗ trợ</h4>
                        <ul className="text-sm text-slate-700 space-y-1">
                            <li>• Xem phản hồi của sinh viên</li>
                            <li>• Trả lời câu hỏi</li>
                            <li>• Đánh dấu đã xử lý</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                <h3 className="text-lg font-semibold text-yellow-900 mb-2">📊 Import sinh viên hàng loạt</h3>
                <ol className="text-slate-700 space-y-2 list-decimal list-inside">
                    <li>Vào <strong>Quản trị → Quản lý người dùng</strong></li>
                    <li>Nhấn <strong>"Download CSV Template"</strong> để tải file mẫu</li>
                    <li>Điền thông tin sinh viên vào file CSV (cột: name;email;password)</li>
                    <li>Lưu file và upload lên hệ thống</li>
                    <li>Hệ thống sẽ báo cáo số sinh viên tạo thành công/thất bại</li>
                </ol>
                <p className="mt-3 text-sm text-yellow-700">
                    <strong>Lưu ý:</strong> File CSV phải sử dụng dấu chấm phẩy (;) làm phân cách, không phải dấu phẩy (,)
                </p>
            </div>
        </div>
    );
};

export default AdminSection;
